@let counts = totalCounts();

<div id="alert-feed-widget">
  <div id="alert-feed-scaled-container">
    <div class="status-total-numbers box no-border">
      <div class="pending status-numbers">
        <div class="status-count">{{ counts.pending }}</div>
        <div class="status-name">{{ 'MAP.PENDING' | translate }}</div>
      </div>
      <div class="vertical-divider"></div>
      <div class="in-progress status-numbers">
        <div class="status-count">{{ counts.inProgress }}</div>
        <div class="status-name">{{ 'MAP.IN-PROGRESS' | translate }}</div>
      </div>
    </div>

    @if (isReady()) {
      <div class="alerts-container">
        @for (alert of alerts(); track alert.uId) {
          <topo-alert-card [config]="alert" />
        }
      </div>
    }
  </div>
</div>
